import { __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import styles from './Table.module.scss.js';

var isNotSafariBrowser = !/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var TableRow = function (props) {
    var index = props.index, onRowClick = props.onRowClick, style = props.style, rowData = props.rowData, rowHeight = props.rowHeight, collapsibleContentHeight = props.collapsibleContentHeight, collapsibleContentGetter = props.collapsibleContentGetter, keyGetter = props.keyGetter, customRowRenderer = props.customRowRenderer, isCollapsible = props.isCollapsible, collapsibleRowClassName = props.collapsibleRowClassName, expandedRowKey = props.expandedRowKey, expandedRowKeys = props.expandedRowKeys, nonCollapsibleRowIndexes = props.nonCollapsibleRowIndexes, columns = props.columns, className = props.className;
    var Tag = onRowClick ? 'button' : 'div';
    var currentKey = expandedRowKey;
    var key = keyGetter({ index: index });
    if (expandedRowKeys === null || expandedRowKeys === void 0 ? void 0 : expandedRowKeys.length) {
        var openedRowByIndex = expandedRowKeys.find(function (value) { return value === +index; });
        if (typeof openedRowByIndex === 'number') {
            currentKey = openedRowByIndex.toString();
        }
    }
    var wrapperProps = {
        'aria-rowindex': index + 1,
        role: 'row',
        className: className,
    };
    if (onRowClick) {
        wrapperProps['aria-label'] = 'clickable row';
        wrapperProps.tabIndex = 0;
        wrapperProps.role = 'button';
        wrapperProps.onClick = function (event) {
            onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick({ event: event, index: index, rowData: rowData });
        };
    }
    var defaultCollapsibleRowContentRenderer = function (_a) {
        var className = _a.className, style = _a.style, columns = _a.columns;
        return (React__default.createElement("div", { className: className, style: style }, columns));
    };
    if (isCollapsible) {
        var classNames = clsx(styles.Collapsible, isNotSafariBrowser && styles.Collapsible___withTransition, collapsibleRowClassName);
        var isRowCollapsible = isCollapsible && !(nonCollapsibleRowIndexes === null || nonCollapsibleRowIndexes === void 0 ? void 0 : nonCollapsibleRowIndexes.includes(index));
        var collapsibleRenderer = customRowRenderer || defaultCollapsibleRowContentRenderer;
        return (React__default.createElement(Tag, __assign({}, wrapperProps, { className: classNames, key: key, style: style }),
            collapsibleRenderer(__assign(__assign({}, props), { style: {
                    height: rowHeight,
                } })),
            keyGetter({ index: index }) === currentKey && isRowCollapsible && (React__default.createElement("div", { className: styles.Collapsible_content, style: { height: collapsibleContentHeight } }, collapsibleContentGetter &&
                collapsibleContentGetter({ index: index })))));
    }
    if (!customRowRenderer) {
        return (React__default.createElement(Tag, __assign({}, wrapperProps, { style: style, key: key }), columns));
    }
    return customRowRenderer(__assign(__assign({}, props), wrapperProps));
};

export { TableRow, TableRow as default };
